/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Delivery_FailedInputs */

const vi_notif_type_delivery_failed = /** @type {(inputs: Notif_Type_Delivery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thất bại`)
};

/**

* @param {Notif_Type_Delivery_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_delivery_failed = /** @type {((inputs?: Notif_Type_Delivery_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Delivery_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_delivery_failed(inputs)
});